import type { AxisKey } from "@/types/ab-tests";

export const SESSION_DRAFT_KEY = "signal-ab-test-draft";

export const AXIS_KEYS: AxisKey[] = ["benefit", "audience", "use-case", "ingredient", "format"];

export const AXIS_LABEL: Record<AxisKey, string> = {
  benefit: "Benefit",
  audience: "Audience",
  "use-case": "Use-case",
  ingredient: "Ingredient / Material",
  format: "Form factor",
};

export const AXIS_HIGHLIGHT_BG: Record<AxisKey, string> = {
  benefit: "bg-green-100 dark:bg-green-900/30",
  audience: "bg-blue-100 dark:bg-blue-900/30",
  "use-case": "bg-amber-100 dark:bg-amber-900/30",
  ingredient: "bg-orange-100 dark:bg-orange-900/30",
  format: "bg-pink-100 dark:bg-pink-900/30",
};

export const AXIS_DOT_BG = AXIS_HIGHLIGHT_BG;

export const FORMAT_TREATMENTS: {
  key: string;
  label: string;
  description: string;
  options: { value: string; label: string }[];
}[] = [
  {
    key: "leadPhrase",
    label: "Change the lead phrase",
    description: "Reorder so the first non-product-name zone leads with a specific angle.",
    options: [
      { value: "benefit", label: "Benefit-led" },
      { value: "audience", label: "Audience-led" },
      { value: "ingredient", label: "Ingredient-led" },
      { value: "usecase", label: "Use-case-led" },
    ],
  },
  {
    key: "length",
    label: "Change length",
    description: "Tighten or expand phrasing within the ~200 character title budget.",
    options: [
      { value: "short", label: "Shorter" },
      { value: "long", label: "Longer" },
    ],
  },
  {
    key: "hyphenation",
    label: "Change hyphenation & punctuation",
    description: "Adjust rhythm from smooth sentence-like to chunked, scannable blocks.",
    options: [
      { value: "minimal", label: "Minimal" },
      { value: "moderate", label: "Moderate" },
      { value: "heavy", label: "Heavy" },
    ],
  },
];
